import { render, staticRenderFns } from "./maintenspk.vue?vue&type=template&id=650f40fc"
import script from "./maintenspk.vue?vue&type=script&lang=js"
export * from "./maintenspk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports